import React, { useState, useEffect } from "react"
import { Link } from "gatsby"
import "./CookieConsent.css"

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false)

  useEffect(() => {
    // Check if user has already accepted cookies
    const cookieConsent = localStorage.getItem('cookieConsent')
    if (!cookieConsent) {
      // Show banner after a short delay to avoid layout shift
      const timer = setTimeout(() => {
        setShowBanner(true)
      }, 1000)
      return () => clearTimeout(timer)
    }
  }, [])

  const handleAccept = () => {
    // Set consent in localStorage with expiration (1 year from now)
    const expirationDate = new Date()
    expirationDate.setFullYear(expirationDate.getFullYear() + 1)
    
    localStorage.setItem('cookieConsent', JSON.stringify({
      accepted: true,
      timestamp: new Date().toISOString(),
      expires: expirationDate.toISOString()
    }))
    
    setShowBanner(false)
  }

  const handleDecline = () => {
    // Set decline in localStorage (expires in 30 days)
    const expirationDate = new Date()
    expirationDate.setDate(expirationDate.getDate() + 30)
    
    localStorage.setItem('cookieConsent', JSON.stringify({
      accepted: false,
      timestamp: new Date().toISOString(),
      expires: expirationDate.toISOString()
    }))
    
    setShowBanner(false)
  }

  if (!showBanner) {
    return null
  }

  return (
    <div className="cookie-consent-banner">
      <div className="cookie-consent-content">
        <div className="cookie-consent-text">
          <p>
            We use cookies to improve your browsing experience and provide analytics to help us understand how our site is used. 
            {" "}
            <Link to="/cookie-policy/" className="cookie-policy-link">
              Learn more about our cookies
            </Link>
          </p>
        </div>
        <div className="cookie-consent-buttons">
          <button 
            onClick={handleDecline}
            className="cookie-btn cookie-btn-decline"
            aria-label="Decline cookies"
          >
            Decline
          </button>
          <button 
            onClick={handleAccept}
            className="cookie-btn cookie-btn-accept"
            aria-label="Accept cookies"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  )
}

export default CookieConsent 